import { render } from "./AuthSection.vue?vue&type=template&id=6fbc8f53"
import script from "./AuthSection.vue?vue&type=script&lang=js"
export * from "./AuthSection.vue?vue&type=script&lang=js"

import "./AuthSection.vue?vue&type=style&index=0&id=6fbc8f53&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__